import React from 'react';
import Spinner from 'Components/Shared/Spinner/Spinner';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';
import PickSeatAutomaticContainer from 'Components/PickSeatAutomatic/PickSeatAutomaticContainer';
import FetchFailureMessage from 'Components/Shared/FetchFailureMessage/FetchFailureMessage';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import DateSpan from 'Components/Shared/DateSpan/DateSpan';

interface IProps {
  isFetching: boolean;
  isFetchFailed: boolean;
  isOpenForSale: boolean;
  isOpeningSoon: boolean;
  isInvalidOrderItem: boolean;
  startSaleDate: Date;
  onPickSeatsManually: () => void;
  onPickSeatsAutomatically: () => void;
}

const OrderStartPage: React.SFC<IProps> = ({ 
  isFetching,
  isFetchFailed,
  isOpenForSale,
  isOpeningSoon,
  isInvalidOrderItem,
  startSaleDate,
  onPickSeatsManually,
  onPickSeatsAutomatically,
}) => {

  if (isFetching) {
    return <Spinner height='lg' />;
  }

  if (isFetchFailed) {
    return (
      <WrapperBox>
        <FetchFailureMessage />
      </WrapperBox>  
    );
  }
  
  if (isInvalidOrderItem) {
    return (
      <WrapperBox>
        <FormattedText 
          displayName='Kunde inte hitta evenemanget du letar efter...'
          formattedName='order.message.invaliditem'
        />
      </WrapperBox>
    )
  }

  if (isOpeningSoon) {
    return (
      <WrapperBox>
        <FormattedText 
          style='title black'
          displayName='Biljettsläpp'
          formattedName=''
        />
        <DateSpan 
          dateFormat='long' 
          firstDate={ startSaleDate } 
        />
      </WrapperBox>
    )
  }

  if (!isOpenForSale) {
    return (
      <WrapperBox>
        <FormattedText 
          style='title black'
          displayName='Stängd för försäljning'
          formattedName='event.closed'
        />
      </WrapperBox>
    )
  }
  
  return (
    <WrapperBox>
      <PickSeatAutomaticContainer { ... { onPickSeatsManually, onPickSeatsAutomatically } } />
    </WrapperBox>
  );
}

export default OrderStartPage;


// WEBPACK FOOTER //
// ./src/pages/OrderStartPage/OrderStartPage.tsx